import React from 'react';
import { Tabs } from 'antd';
import UnitOffersList from './UnitOffersList';
import UnitOfferCalendarView from './UnitOfferCalendarView';

const { TabPane } = Tabs;

const UnitOffers = () => {
  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Calendar view" key="1">
          <UnitOfferCalendarView />
        </TabPane>
        <TabPane tab="List view" key="2">
          <UnitOffersList />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default UnitOffers;
